import { useState } from "react"
import { Button } from "react-bootstrap"
import BackButtonHeader from "../../../components/buttons/BackButtonHeader"
import NewMemberForm from "../components/NewMemberForm"
import ExistingMemberForm from "../components/ExistingMemberForm"

const CreateAccountPage = () => {
  const [isNewMember, setIsNewMember] = useState(false)

  const currentClass = "border-0 fw-semibold rounded-3 shadow-btn bg-white opacity-100 no-pointer"
  const inactiveClass = "fw-semibold rounded-3 border-0 custom-hover border-bottom border-2 text-muted"

  return (
    <div className="w-100">
      <BackButtonHeader page="Create Account" />

      <div
        className="w-100 mx-auto bg-white shadow-sm rounded-4 p-4">
        <div className="d-flex justify-content-center align-items-center gap-4 mt-2 mb-4">
          <Button onClick={() => setIsNewMember(false)} variant="" className={!isNewMember ? currentClass : inactiveClass} style={{ width: "150px" }}>Existing Member</Button>
          <Button onClick={() => setIsNewMember(true)} variant="" className={isNewMember ? currentClass : inactiveClass} style={{ width: "150px" }}>New Member</Button>
        </div>
        <h4 className="my-3 fw-bold ps-2">Login Details</h4>

        {isNewMember ? <NewMemberForm isNewMember={isNewMember} /> : <ExistingMemberForm isNewMember={isNewMember} />}

      </div>
    </div>
  )
}

export default CreateAccountPage